// extracted by mini-css-extract-plugin
export default {"rating_text":"stars_rating_text__Ti5Y6","course_details_block":"stars_course_details_block__5KYED"};